class headerSearchExtendNew extends HTMLElement {
  constructor() {
    super();
    this.searchOpenButton = this.querySelector('[data-search-open]');
    this.searchCloseButton = this.querySelector('[data-search-close]');
    this.searchPopup = this.querySelector('[data-search-popup]');
    this.searchPopupInner = this.searchPopup?.querySelector('.header-search-popup__inner');
  }

  connectedCallback() {
    this.searchOpenButton.addEventListener('click', this.openSearchPopup.bind(this));
    this.searchCloseButton.addEventListener('click', this.closeSearchPopup.bind(this));
    this.searchPopup.addEventListener('click', (event) => {
      if (event.target === this.searchPopup) {
        this.closeSearchPopup();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') {
        this.closeSearchPopup();
      }
    });
  }

  openSearchPopup(event) {
    event.preventDefault();

    if (this.searchPopup) {
      this.searchPopup.classList.remove('invisible', 'opacity-0');
      this.searchPopup.classList.add('visible', 'opacity-100');
      this.searchPopupInner?.classList.remove('translate-x-full');
      this.searchPopupInner?.classList.add('translate-x-0');
    }
  }

  closeSearchPopup() {
    if (this.searchPopup) {
      this.searchPopup.classList.remove('opacity-100');
      this.searchPopup.classList.add('opacity-0');
      this.searchPopupInner?.classList.remove('translate-x-0');
      this.searchPopupInner?.classList.add('translate-x-full');

      setTimeout(() => {
        this.searchPopup.classList.remove('visible');
        this.searchPopup.classList.add('invisible');
      }, 350);
    }
  }
}

if(!customElements.get('header-search-extend-new')) {
  customElements.define('header-search-extend-new', headerSearchExtendNew);
}